import { LocalizedDateFromUtc, SpacedDash } from '@mews-commander/ui';

interface ReportTitleProps {
    startDate: string;
    endDate: string;
}

export const ReportTitle = ({ startDate, endDate }: ReportTitleProps) => (
    <>
        <LocalizedDateFromUtc utcString={startDate} />
        {SpacedDash}
        <LocalizedDateFromUtc utcString={endDate} />
    </>
);
